// The API answers 409 with `field: 'username'` when a brand or promoter picks
// a name another account already goes by (T2B-433).
export const isNameTakenError = (err) =>
  err?.response?.status === 409 && err?.response?.data?.field === 'username';
